export default __webpack_public_path__ + "static/media/mkr.af4d24f0.svg";